import { NgbDateStruct, NgbTimeStruct } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { ProgressBar } from "../bundles/models.bundle";

export function padNumber(value: number) {
    if (isNumber(value)) {
        return `0${value}`.slice(-2);
    } else {
        return "";
    }
}

export function isNumber(value: any): boolean {
    return !isNaN(toInteger(value));
}

export function toInteger(value: any): number {
    return parseInt(`${value}`, 10);
}

const jsToday = new Date();
export class DateHelper {
    static readonly today: NgbDateStruct = { year: jsToday.getFullYear(), month: jsToday.getMonth() + 1, day: jsToday.getDate() };
    static getDate(date: NgbDateStruct) {
        return date.year + "-" + padNumber(date.month) + "-" + padNumber(date.day);
    }

    static getJSDate(date: NgbDateStruct) {
        const dateNew = new Date(date.year, date.month - 1, date.day);
        return new Date(dateNew.getTime() + Math.abs(dateNew.getTimezoneOffset() * 60000));
    }

 
  static getJSDateTime(date: NgbDateStruct, time: NgbTimeStruct) {
    const dateNew = new Date(date.year, date.month - 1, date.day, time.hour, time.minute, time.second);
    return dateNew;
  }
    static getNgbDate(date: Date) {
        date = new Date(date);
        return { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
    }

    static getStringDate(date: Date) {
        date = new Date(date);
        return padNumber(date.getMonth() + 1) + "/" + padNumber(date.getDate()) + "/" + date.getFullYear();
    }

    // to get string date with MMDDYYYY format
    static getStringDate_MMDDYYYY(date: Date) {
        date = new Date(date);
        return padNumber(date.getMonth() + 1) + padNumber(date.getDate()) + date.getFullYear();
    }

    static getProgressBar(endDate: Date): ProgressBar {
        const model = new ProgressBar();
        model.value = parseInt(moment().format("DDD"));
        model.min = 0;
        model.max = 0;
        let toYear = parseInt(moment().format("YYYY"));
        const endYear = parseInt(moment(endDate).format("YYYY"));

        for (let i = toYear; i <= endYear; i++) {
            if (toYear === endYear) {
                model.max += parseInt(moment(endDate).format("DDD"));
            } else {
                model.max += parseInt(moment(new Date(toYear, 11, 31)).format("DDD"));
            }
            toYear++;
        }
        model.percentage = (model.value / model.max) * 100 + "%";
        return model;
    }
}
